module.exports = __webpack_public_path__ + "img/cover.80d93760.jpg";